import useMarket from 'stores/useMarket';
import { useDeleteFromCartMutation, useSaveToCartMutation } from '../generated/graphql';
import useUser from '../stores/useCustomer';

type UpdateCartItemProps = {
    productId: number;
    childId?: number;
    quantity: number;
    additional?: {
        productChildId?: number;
    };
    completedMessage?: string;
};

export function useCart() {
    const { cartId, setCartId } = useUser();
    const [saveToCartMutation] = useSaveToCartMutation({
        refetchQueries: ['getCart'],
        onCompleted: (data) => {
            if (data.saveToCart?.cartId) {
                setCartId(data.saveToCart.cartId);
            }
        },
    });
    const [deleteFromCartMutation] = useDeleteFromCartMutation({ refetchQueries: ['getCart'] });
    const { market } = useMarket((state) => state);

    const updateCartItem = (
        {
            productId,
            childId,
            quantity,
        }: UpdateCartItemProps,
    ) => {
        saveToCartMutation({
            variables: {
                market,
                item: {
                    productId,
                    childId,
                    quantity,
                },
            },
        });
    };

    const deleteFromCart = (productId: number, childId: number | undefined) => {
        if (!cartId) {
            const errorMessage = 'Cart ID is not set, cannot delete from cart.';
            throw new Error(errorMessage);
        }

        return deleteFromCartMutation({
            variables: {
                productId,
                childId,
            },
        });
    };

    return {
        addToCart: updateCartItem,
        deleteFromCart,
    };
}
